import { render } from "./VerifyOTP.vue?vue&type=template&id=a6196818&scoped=true"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"

import "./VerifyOTP.vue?vue&type=style&index=0&id=a6196818&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6196818"]])

export default __exports__